export const DISTANCE_AND_READING = 'distance_and_reading';

export const DISTANCE_AND_READING_DESCRIPTION = {
    sku: DISTANCE_AND_READING,
    title: 'Distance & Reading',
    subtitle: 'Multifocal',
    description: 'Provide seamless progression between optical powers for all viewing distances.',
    sort: 3,
    node: DISTANCE_AND_READING,
};

export const NOPRESCRIPTION = 'Frame';
export const DISTANCE = 'Single-Vision';
export const PROGRESSIVES = 'Progressive';
export const BIFOCAL = 'Bifocal';
export const READING = 'Reading';
export const OFFICE_NEAR = 'OfficeNear';

/**
 *  constant which contains usages that will be hidden
 *  FOR BOTH WIZARDS
 */
export const USAGES_TO_HIDE = [OFFICE_NEAR];
export const PROGRESSIVE_USAGES = [PROGRESSIVES, OFFICE_NEAR];
export const PROGRESSIVE_DISCOUNT_PRICE = 75;
